'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoNaviconRound = function IoNaviconRound(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.6 17.5c1.3 0 2.4 1.1 2.4 2.5s-1.1 2.5-2.4 2.5h-25.2c-1.3 0-2.4-1.1-2.4-2.5s1.1-2.5 2.4-2.5h25.2z m0-10c1.3 0 2.4 1.1 2.4 2.5s-1.1 2.5-2.4 2.5h-25.2c-1.3 0-2.4-1.1-2.4-2.5s1.1-2.5 2.4-2.5h25.2z m0 20c1.3 0 2.4 1.1 2.4 2.5s-1.1 2.5-2.4 2.5h-25.2c-1.3 0-2.4-1.1-2.4-2.5s1.1-2.5 2.4-2.5h25.2z' })
        )
    );
};

exports.default = IoNaviconRound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/navicon-round.js
// module id = 2844
// module chunks = 168707334958949